import React from 'react';

import WebNavigation from 'navigation/WebNavigation';

const App = () => {
  return (
    <WebNavigation />
  );
}

export default App;
